module.exports = __webpack_public_path__ + "static/komunikacja2-bba81f07aad8aab09570e495a6144e58.jpg";